import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from '../context/LanguageContext';
import { Home, UploadCloud, Receipt, Building2, User, Lock, Dice5 } from 'lucide-react';

export const BottomNav: React.FC = () => {
  const { t } = useTranslation();

  const navItems = [
    { to: '/', label: t('nav.dashboard'), icon: Home },
    { to: '/submit', label: t('nav.submit'), icon: UploadCloud },
    { to: '/history', label: t('nav.history'), icon: Receipt },
    { to: '/ledger', label: 'Ledger', icon: Lock },
    { to: '/lottery', label: 'Lottery', icon: Dice5 },
    { to: '/profile', label: t('nav.profile'), icon: User },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white/95 dark:bg-navy-900/95 backdrop-blur-md border-t border-gray-200 dark:border-navy-800 pb-safe sm:hidden">
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center flex-1 h-full py-1 text-xs font-medium transition-colors ${
                isActive
                  ? 'text-primary-600 dark:text-primary-400 font-semibold'
                  : 'text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100'
              }`
            }
          >
            <Icon className="w-5 h-5 mb-1" />
            <span className="truncate max-w-[64px]">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
